export default {
    nav: {
      home: "首页",
      products: "产品",
      contact: "联系我们",
      about: "关于我们",
      download: "APP下载",
      app_download: "应用下载",
      leecho: "Le-Echo",
      levue: "乐见",
      lebond: "乐伴",
      lesound: "乐音",
      menu: "菜单"
    },
    swiper: {
      _1: ["智能表系列", "了解更多"],
      _2: ["齿轮箱表系列", "了解更多"],
      _3: ["滚轮表系列", "了解更多"]
    },
    about: {
      text_0: "关于我们",
      text_1: "深圳美乐创科技有限公司，是一家手表行业技术平台服务公司，公司前身是香港aupo从业30多年钟表专业公司，2008年转型为手表行业提供技术服务，公司拥有①香港传统表专业团队②深圳硬件、软件、app专业团队③中山工厂基地生产团队④为传统表品牌及行业品牌提供，智能表，（齿轮箱+模组）自定义指针功能机芯，技术支持。",
      text_2: "技术服务项目内容如下:",
      text_3: "一，智能手表蓝牙方案服务商",
      text_4: "① 蓝牙方案（拥有源代码，支持功能定制服务）",
      text_5: "② 4G智能表方案",
      text_6: "③ 硬件、软件、app技术服务",
      text_7: "④ 内容、界面、UI、定制",
      text_8: "⑤ 智能表售后服务，app升级",
      text_9: "二，（齿轮箱+模组）自定义指针功能机芯",
      text_10: "① 自定义指针功能机芯，打破传统表先有机芯再设计手表模式，转变为由手表品牌商先定义手表产品功能和设计表盘布局，我公司提供机芯结构+硬件堆叠+软件程序技术服务",
      text_11: "② 手表品牌商可以任意排列机芯轴的位置，选择机芯轴高度，选择同心多轴或单轴齿轮箱，正转、反转、转速、独立马达驱动",
      text_12: "③ 选择机芯轴用途，计时针、计量针、动感动作，如模拟车轮转动、动物动作、飞鸟、蝴蝶动作、卡通人物动作等创意",
      text_13: "④ 齿轮箱可选择瑞士朗达、日本西铁城、精工、大陆等，丰俭由人",
      text_14: "⑤ 科技发展，手表智能化、功能化需要跨界技术合作，传统机芯厂只提供专业齿轮箱，把手表产品定义交给手表品牌商，我公司提供机芯结构+硬件、软件专业技术平台服务",
      text_15: "⑥ （齿轮箱+模组）自定义指针功能机芯，分为两大类，A，指针智能表（带app），B，指针功能表（不带app）"
    },
    contact: {
      title: "联系我们",
      items: [
        {
          name: {
            name: "联系人",
            value: "陈生"
          },
          changer: {
            name: "负责",
            value: "智能手表"
          },
          tel: {
            name: "联系电话",
            value: "13794477351"
          },
          email: {
            name: "E-mail",
            value: "json@mltcloud"
          }
        },
        {
          name: {
            name: "联系人",
            value: "黄生"
          },
          changer: {
            name: "负责",
            value: "可编辑齿轮箱手表"
          },
          tel: {
            name: "联系电话",
            value: "15626563096"
          },
          email: {
            name: "E-mail",
            value: "cliffwong65@yahoo.com"
          }
        }
    ],
    address: [
      {
        addrName: '深圳公司',
        companyName: "深圳美乐创科技有限公司",
        addr: "深圳市宝安区固戍一路378号B栋厂房306"
      },
      {
        addrName: '香港公司',
        companyName: "恒锐投资有限公司",
        addr: "香港九龙大角咀榆树街1号宏业工业大厦10楼1003室"
      },
      {
        addrName: '中山工厂',
        companyName: "中山中科美创智能科技有限公司",
        addr: "中山市南朗镇榄边村长岭路3号"
      }
    ]
  },
  products: {
    title: "产品",
    titleList: [
      {
        t_1: "产品及技术",
        t_2s: ["智能表系列", "齿轮箱表系列", "滚轮表系列"]
      }
    ],
    productList: ["智能表系列", "齿轮箱表系列", "滚轮表系列"]
  },
  download: "扫描二维码下载",
  download_page: {
    title: "APP下载",
    download_btn: "下载",
    qr_desc: "扫描上方二维码，即可快速下载我们的应用程序。支持 iOS 和 Android 双平台。",
    quick_links: "快速链接",
    contact: "联系我们"
  },
  footer_desc: "深圳美乐创科技有限公司，是一家手表行业技术平台服务公司。",
  footer_support: "服务支持",
  leecho: {
    title: "Le-Echo 智能眼镜应用",
    subtitle: "为智能眼镜打造的创新应用，集成智能交互与个性化服务于一体",
    description: "Le-Echo是一款专为智能眼镜打造的创新应用，集成智能交互与个性化服务于一体，为用户带来无缝衔接的数字与现实体验。通过高效语音控制、实时视觉分析及情境感知技术，Le-Echo重新定义您感知世界的方式——无论是通讯、娱乐还是工作，一切尽在眼前。",
    feature1: {
      title: "高效语音控制",
      description: "通过先进的语音识别技术，实现对智能眼镜的精准控制，让您的双手得到解放"
    },
    feature2: {
      title: "实时视觉分析",
      description: "利用AI视觉技术，实时分析周围环境，为您提供智能化的信息提示和建议"
    },
    feature3: {
      title: "情境感知技术",
      description: "智能感知当前场景和环境，自动调整应用功能，提供最适合的服务体验"
    },
    download: {
      title: "立即下载",
      ios_label: "iOS 下载",
      ios_text: "App Store",
      android_label: "Android 下载",
      android_text: "Android"
    },
    footer: "无论是通讯、娱乐还是工作，Le-Echo让一切尽在眼前",
    agreement: {
      prefix: "点击下载即表示您同意",
      user: "《用户协议》",
      and: "和",
      privacy: "《隐私政策》"
    }
  },
  footerNav: ["联系我们", "关于我们", "常见问题", "条款及细则"],
  footerFollow: "关注我们"
};
